import * as machineRelations from './full'
import * as machineRelationsShort from './short'

import {
    MachineRelation,
    MachineRelationShort,
} from 'app/types/park/machineRelation'

export const allMachineRelationsShort: MachineRelationShort[] = Object.values(
    machineRelationsShort,
)

export const allMachineRelations: MachineRelation[] =
    Object.values(machineRelations)
